import styled from '@emotion/styled';
import { Box } from '@kc-console/common-ui';

import { MediaQuery } from '../../constants';

import type { PropsWithChildren } from 'react';

/**
 * GNB 포함 에러 레이아웃 컴포넌트
 *
 * @description
 * GNB가 포함된 에러 컴포넌트를 위한 레이아웃입니다.
 * GeneralLayout의 MainContent 영역에 표시되며, 중앙 정렬된 컨테이너로 자식 요소들을 배치합니다.
 * 반응형 처리를 포함합니다.
 *
 * @example
 * ```tsx
 * <WithGnbErrorLayout>
 *   <RegionUnsupported />
 * </WithGnbErrorLayout>
 * ```
 */
export const WithGnbErrorLayout = ({ children }: PropsWithChildren) => {
  return <LayoutContainer>{children}</LayoutContainer>;
};

const LayoutContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 40px;

  ${MediaQuery.TIL_SMALL} {
    padding: 24px;
  }

  ${MediaQuery.EXTRA_SMALL} {
    padding: 16px;
  }
`;
